import { render, staticRenderFns } from "./clientLayout.vue?vue&type=template&id=b52dbdda&scoped=true&"
import script from "./clientLayout.vue?vue&type=script&lang=js&"
export * from "./clientLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52dbdda",
  null
  
)

export default component.exports